'use client';

import {createContext, useContext} from 'react';

const AppThemeContext = createContext(false);

export const useAppTheme = () => useContext(AppThemeContext);

export default AppThemeContext;
